import { Modal } from "antd";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import useForm from "../../hooks/useForm";
import { useThunk } from "../../hooks/useThunk";
import { COMMON_FIELD_TYPES } from "../../constants/fieldTypes";
import { roles } from "../../constants/commonConstants";
import { closeSignInModal, signin, startDataRefresh } from "../../store";

import CustomInput from "../Form/Input";
import CustomButton from "../Form/CustomButton";
import showToast from "../../utils/toastNotifications";

import { Eye, EyeOff } from "lucide-react";

const SignIn = ({ isOpen, onClose, onForgotPassword, isModel = false }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const { role } = useSelector((state) => state.auth);

  const [showPassword, setShowPassword] = useState(false);

  const [doSignin, isSigninIn, signinError] = useThunk(signin);

  const {
    formData,
    errors,
    touched,
    handleInputChange,
    handleBlur,
    validateForm,
    setTouched,
    setFormData,
    clearError,
  } = useForm(
    {
      email: "",
      password: "",
      rememberMe: false,
    },
    {
      email: true,
      password: true,
      rememberMe: false,
    },
    {
      email: COMMON_FIELD_TYPES.EMAIL_FIELD,
      password: COMMON_FIELD_TYPES.PASSWORD_FIELD,
      rememberMe: COMMON_FIELD_TYPES.BOOLEAN_FIELD,
    }
  );

  const handleSubmit = async (e) => {
    e.preventDefault();

    setTouched({
      email: true,
      password: true,
      rememberMe: true,
    });

    const { rememberMe, ...otherData } = formData;
    if (validateForm()) {
      const result = await doSignin(otherData);
      if (result?.success) {
        showToast("success", "Login Sucessfull");
        onClose();
        // navigate("/");
      } else {
        showToast("error", result?.error?.message);
      }
    }
  };

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width={500}
      centered
      className="confirmation-modal relative"
      style={{
        backgroundColor: "#F6FCFF",
        borderRadius: "16px",
      }}
    >
      <div className="h-[400px] sm:h-[450px] max-w-[547px] flex flex-col items-center justify-start my-4 sm:my-8">
        <h1 className="text-auth-level-1 font-semibold font-poppins">
          <span className="text-roselea-green">Sign </span>
          <span className="text-roselea-pink">In</span>
        </h1>

        <form className="w-full">
          <div className="flex flex-col gap-3 mt-[24px] sm:mt-[40px]">
            <CustomInput
              label=""
              type="text"
              name="email"
              value={formData.email}
              error={touched.email && errors.email}
              onChange={(e) => handleInputChange("email", e.target.value)}
              onBlur={() => handleBlur("email", formData.email)}
              onFocus={() => clearError("email")}
              placeholder="Enter your email address"
              className="w-full h-[54px] px-3 rounded-[12px] border border-input-border-roselea-green bg-primary-light/30 text-gray-600"
              labelStyle="font-alexandria font-medium  sm:text-[16px] text-dark"
              inputStyle="bg-input-roselea-green bg-opacity-[0.03]"
              isRequired={true}
            />

            <div className="relative">
              <CustomInput
                label=""
                type={showPassword ? "text" : "password"}
                name="password"
                value={formData.password}
                error={touched.password && errors.password}
                onChange={(e) => handleInputChange("password", e.target.value)}
                onBlur={() => handleBlur("password", formData.password)}
                onFocus={() => clearError("password")}
                placeholder="Enter your password"
                className="w-full h-[54px] px-3 rounded-[12px] border border-input-border-roselea-green bg-primary-light/30 text-gray-600"
                labelStyle="font-alexandria font-medium sm:text-[16px] text-dark"
                inputStyle="bg-input-roselea-green bg-opacity-[0.03]"
                isRequired={true}
              />
              <button
                type="button"
                className="absolute right-4 top-[30px] -translate-y-1/2 text-gray-500"
                onClick={() => setShowPassword((prev) => !prev)}
                tabIndex={-1}
              >
                {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
              </button>
            </div>
          </div>

          {/* <div className="flex items-center justify-between mt-12 xs:mt-8">
            <label className="flex items-center gap-3 text-[#718096] font-inter text-[12px] sm:text-[14px]">
              <input
                type="checkbox"
                name="rememberMe"
                checked={formData.rememberMe}
                onChange={(e) =>
                  handleInputChange("rememberMe", e.target.checked)
                }
                className="w-4 h-4 accent-[#4772F1]"
              />
              <span>Remember me</span>
            </label>
          </div> */}

          <div className="absolute bottom-[30px] sm:bottom-[60px] left-0 w-full p-[20px]">
            <CustomButton
              type="submit"
              className="h-[50px] sm:h-[45px] bg-roselea-pink text-roselea-white font-poppins font-semibold text-[16px] leading-[28px] rounded-[12px]"
              buttonText="Login"
              onClick={handleSubmit}
              loading={isSigninIn}
              disabled={isSigninIn}
            />

            <div className="flex justify-center mt-4">
              <Link
                to="#"
                className="font-medium underline text-button-roselea-green font-poppins text-[12px] sm:text-[14px] toc-link-sign-in"
                onClick={(e) => {
                  e.preventDefault();
                  if (onForgotPassword) onForgotPassword();
                }}
              >
                Forgot Password?
              </Link>
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default SignIn;
